import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import { PublicRoute, PrivateRoute } from "./helpers/";

import Home from "./views/home/Home";
import Signin from "./views/auth/Signin";
import Signup from "./views/auth/Signup";
import Dashboard from "./views/dashboard/Dashboard";
import SaqA from "./views/saqs/SaqA";
import Drafts from "./views/saqs/Drafts";
import Completed from "./views/saqs/Completed";
import SaqB from "./views/saqs/SaqB";
import SaqbIp from "./views/saqs/SaqbIp";
import NotFound from "./views/errors/NotFound";
import SaqC from "./views/saqs/SaqC";
import EditSaq from "./views/saqs/EditSaq";
import SaqdMe from "./views/saqs/SaqdMe";
import SaqdSp from "./views/saqs/SaqdSp";
import SaqWizard from "./views/saqs/Wizard";
import Tg30UserVerification from "./views/auth/Tg30UserVerification";
import SaqaEp from "./views/saqs/SaqaEp";
import ForgotPassword from "./views/auth/ForgotPassword";
import UpdatePassword from "./views/auth/UpdatePassword";
import Demo from "./views/saqs/Demo";
import BusinessSelection from "./views/business/BusinessSelection";
import WhiteLabelAdminSignup from "./views/auth/WhiteLabelAdminSignup";
import WhiteLabelUserSignup from "./views/auth/WhiteLabelUserSignup";
import WhiteLabelSignin from "./views/auth/WhiteLabelSignin";
import WhiteLabelSubdomain from "./views/auth/WhiteLabelSubdomain";
import WhiteLabelControlPanel from "./views/controlPanel/whiteLabelControlPanel";
import AdminDashboard from "./views/admin/Dashboard";
import CompanyUsers from "./views/admin/CompanyUsers";
import AdminCompanies from "./views/admin/Companies";
import AdminCompletedSaqs from "./views/admin/Completed";
import AdminDraftSaqs from "./views/admin/Drafts";
import CreateCompany from "./views/admin/CreateCompany";
import CreateUser from "./views/admin/CreateUser";

class App extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route path="/" component={Home} exact />
            <PublicRoute path="/signin" component={Signin} exact />
            <PublicRoute
              path="/signup"
              component={WhiteLabelAdminSignup}
              exact
            />

            {/*** WHITE LABEL ADMIN USER ***/}

            <PublicRoute
              path="/subdomain"
              component={WhiteLabelSubdomain}
              exact
            />
            {/* <PublicRoute
              path="/white-label/signin"
              component={WhiteLabelSignin}
              exact
            /> */}
            <PrivateRoute
              path="/control-panel"
              component={AdminDashboard}
              exact
            />
            <PrivateRoute
              path="/control-panel/users"
              component={CompanyUsers}
              exact
            />
            <PrivateRoute
              path="/control-panel/companies"
              component={AdminCompanies}
              exact
            />
            <PrivateRoute
              path="/control-panel/companies/create/"
              component={CreateCompany}
              exact
            />
            <PrivateRoute
              path="/control-panel/users/create"
              component={CreateUser}
              exact
            />
            <PrivateRoute
              path="/control-panel/completed-saqs"
              component={AdminCompletedSaqs}
              exact
            />
            <PrivateRoute
              path="/control-panel/draft-saqs"
              component={AdminDraftSaqs}
              exact
            />

            {/*** WHITE LABEL ADMIN USER ***/}

            {/*** AUTH WHITE LABEL USER ***/}

            <PublicRoute
              path="/register"
              component={WhiteLabelUserSignup}
              exact
            />
            <PublicRoute path="/login" component={WhiteLabelSignin} exact />

            {/*** AUTH WHITE LABEL USER ***/}

            {/* <PublicRoute
              path="/company-signup"
              component={WhiteLabelSignup}
              exact
            /> */}

            <PublicRoute
              path="/forgot-password"
              component={ForgotPassword}
              exact
            />
            <PublicRoute
              path="/update-password/:code"
              component={UpdatePassword}
              exact
            />
            <PublicRoute
              path="/tg30-user-verified"
              component={Tg30UserVerification}
              exact
            />
            <PrivateRoute
              path="/choose-business"
              component={BusinessSelection}
              exact
            />

            {/* <PrivateRoute
              path="/control-panel"
              component={WhiteLabelControlPanel}
              exact
            /> */}

            {/*** USER SAQ URLS ***/}

            <PrivateRoute path="/dashboard" component={Dashboard} exact />
            <PrivateRoute path="/create/wizard" component={SaqWizard} exact />
            <PrivateRoute path="/drafts" component={Drafts} exact />
            <PrivateRoute path="/completed-saqs" component={Completed} exact />
            <PrivateRoute path="/create/saq-a" component={SaqA} exact />
            <PrivateRoute path="/create/saq-b" component={SaqB} exact />
            <PrivateRoute path="/create/saq-b-ip" component={SaqbIp} exact />
            <PrivateRoute path="/create/saq-c" component={SaqC} exact />
            <PrivateRoute path="/create/saq-d-me" component={SaqdMe} exact />
            <PrivateRoute path="/create/saq-d-sp" component={SaqdSp} exact />
            <PrivateRoute path="/create/saq-a-ep" component={SaqaEp} exact />
            <PrivateRoute
              path="/saq-draft/:saq/:id"
              component={EditSaq}
              exact
            />
            <PrivateRoute path="/demo-download" component={Demo} exact />

            {/*** USER SAQ URLS ***/}

            <Route component={NotFound} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default withRouter(App);
